import $ from 'jquery';
import async from 'async';

class ComponentLoader {
    constructor( props ){
        // Initial values
        this.component = "c_default";
        this.component_list = [];
        this.parent = $('body');

        if( props.hasOwnProperty("component") ){
            this.component = props.component;
        }

        if( props.hasOwnProperty("component_list") ){
            this.component_list = props.component_list;
        }

        if( props.hasOwnProperty("parent") ){
            this.parent = props.parent;
        }
    }

    generateId(){
        let text = "";
        let possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

        for (var i = 0; i < 5; i++)
            text += possible.charAt(Math.floor(Math.random() * possible.length));

        return text;
    }

    renderComponent( custom_callback = null ){
        let component_data = this.component_list[this.component];
        let component_settings = this.component_list[this.component].settings;

        console.log("RENDER COMPONENT ---->", this.component);

        const id = this.generateId();
        const container = $(`<div id="${id}" class="component ${this.component}"></div>`);
        this.parent.append( container  );
        async.series([
            // APPEND CSS 
            ( callback ) => {
                if( !component_data.is_loaded && component_settings.hasOwnProperty("css")){
                    $("<div></div>").load( component_settings.css , ( result ) => {
                        $("head").append(`<style>${result}</style>`);
                        callback( null, 'success' );
                    });
                }else{
                    callback( null, 'success' );
                }
            },
            // APPEND CSS
            ( callback ) => {
                if( !component_data.is_loaded && component_settings.hasOwnProperty("script") ){
                    $("<div></div>").load( component_settings.script , ( result ) => {
                        $("body").append(`<script>${result}</script>`);
                        callback( null, 'success' );
                    });
                }else{
                    callback( null, 'success' );
                }
            },
            // APPEND HTML
            ( callback ) => {
                if( !component_data.is_loaded || !component_settings.hasOwnProperty("html_text") ){
                    console.log("HTML NOT YET LOADED ---> LOADING....", id);
                    $("<div></div>").load( component_settings.html, ( result , status, xhr ) => {
                        // Parse to html
                        const body = result.match(/<body[^>]*>[\s\S]*<\/body>/gi)[0];
                        // console.log("HTML", body);
                        container.html( body );
                        this.component_list[this.component].settings.html_text = body;
            
                        if( typeof custom_callback == 'function' ){
                            custom_callback( $(`#${id}`) );
                        }
            
                        // console.log("HTML LOADED", container, this.parent );
                        callback( null, 'success' );
                    });
                    this.component_list[this.component].is_loaded = true;
                }else{
                    console.log("HTML IS ALREADY AVAILBLE ---> USING...", id);
                    // Assume HTML is already available
                    container.html( this.component_list[this.component].settings.html_text );

                    if( custom_callback != null ){
                        custom_callback( $(`#${id}`) );
                    }
                    callback( null, 'success' );
                }
                
            }

        ], ( err, result )=>{
            if( err ){
                console.log("FAILED!!", err);
            }else{
                console.log("SUCCESS!!", result);
            }
        });
    }
}

export default ComponentLoader;


// WEBPACK FOOTER //
// ./src/component_loader.js